import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/assets/config/config/app-config';

import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class BulkUpdateService {
    apiUrl: string

    constructor(private http: HttpClient,
        private config: AppConfig) {
            this.apiUrl=this.config.getConfig('apiUrl');
    }

    createBulkUpdate(payload) {
        return this.http.post(this.apiUrl+`/bulkOperations/task/create`, payload).pipe();
    }
}